// TextLangEditor.tsx · v12.10.27 (#2154 tokens as chips - ChipEditor) · 2026-10-31 · VoiceSpectrum AI
// TextLangEditor.tsx · v12.10.26 (#T154 an automatic text per language - EN / ES / ZH tabs, + Insert token, preview) · 2026-10-30 · VoiceSpectrum AI
import { useRef, useState } from 'react';
import { ChipEditor, type ChipEditorHandle } from '../aiagent/ChipEditor';   // v12.10.27 (#2154)
import { PHONE_TOKEN, TEXT_LANGS, renderPhone } from '../../lib/texting';
import './texting.css';

export default function TextLangEditor({ value, defaults, officePhone, onChange, disabled }: {
  value: Record<string, string>; defaults: Record<string, string>; officePhone?: string | null;
  onChange: (next: Record<string, string>) => void; disabled?: boolean;
}) {
  const [lang, setLang] = useState('en');
  const ref = useRef<ChipEditorHandle | null>(null);
  const text = value[lang] ?? defaults[lang] ?? '';
  const set = (t: string) => {
    const next = { ...value };
    if (!t.trim() || t === defaults[lang]) delete next[lang]; else next[lang] = t;
    onChange(next);
  };
  const insertToken = () => {
    const at = Math.min(ref.current?.getCaret() ?? text.length, text.length);
    set(text.slice(0, at) + PHONE_TOKEN + text.slice(at));
  };
  return (
    <div className="tx-editor">
      <div className="lang-tabs">
        {TEXT_LANGS.map((l) => (
          <button key={l.code} type="button" className={`lang-tab${lang === l.code ? ' on' : ''}`} onClick={() => setLang(l.code)}>
            {l.label} &middot; {l.code.toUpperCase()}
          </button>
        ))}
      </div>
      {/* v12.10.27 (#2154): tokens show as chips, like the workflow prompt editor (was a plain textarea). key = language so the box
          rebuilds per tab. 480 characters is still the limit. */}
      <ChipEditor key={lang} ref={ref} value={text} rows={3} disabled={disabled} lang={lang}
        labelOf={(t) => (t === 'organization.phone' ? 'Office phone' : undefined)}
        onChange={(v) => set(v.slice(0, 480))} placeholder={`Automatic text, ${lang.toUpperCase()}`} />
      <div className="tx-editor-tools">
        <button type="button" className="tx-token-btn" disabled={disabled} onClick={insertToken}>+ Insert token {PHONE_TOKEN}</button>
        {value[lang] !== undefined && <button type="button" className="tx-token-btn" disabled={disabled} onClick={() => set('')}>Use the default</button>}
      </div>
      <div className="tx-preview"><i>PREVIEW · {lang.toUpperCase()}</i>{renderPhone(text, officePhone)}</div>
    </div>
  );
}
